import React from "react";
import ReactECharts from "echarts-for-react";import { useTranslation } from 'react-i18next';


const NaturalVsCullingChart = ({ chartData = [] }) => {
  const { t } = useTranslation(['common', 'analytics', 'device', 'farm', 'batch', 'user']);
  // Prepare X-axis as day numbers (0, 1, 2, ...)
  const days = chartData.map((item) => item.day.toString());

  // Aggregated values
  const naturalAgg = chartData.map((item) => parseInt(item.Aggregate_Natural));
  const cullingAgg = chartData.map((item) => parseInt(item.Aggregate_Culling));
  const phases = chartData.map((item) => item.Phase);

  // Optional: Phase band label logic
  const phaseBands = [];
  let currentPhase = null;
  for (let i = 0; i < chartData.length; i++) {
    if (!currentPhase || chartData[i].Phase !== currentPhase.phase) {
      currentPhase = {
        phase: chartData[i].Phase,
        startIndex: i,
        endIndex: i,
      };
      phaseBands.push(currentPhase);
    } else {
      currentPhase.endIndex = i;
    }
  }
  const option = {
    tooltip: {
      trigger: "axis",
      formatter: function (params) {
        // params is an array of series data points for that X
        const dayIndex = params[0].dataIndex;
        const day = chartData[dayIndex]?.day;
        const date = chartData[dayIndex]?.Date;

        let tooltipHtml = `<strong>${t('common:time.day')} ${day}</strong><br/><small>${date}</small><br/>`;

        params.forEach((item) => {
          tooltipHtml += `
        <span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:${item.color};"></span>
        ${item.seriesName}: ${item.value}<br/>
      `;
        });

        return tooltipHtml;
      },
    },
    legend: {
      data: ["Natural", "Culling"],
      top: 40,
      left: "center",
    },
    xAxis: {
      type: "category",
      data: days,
      name: t('common:time.day'),
      nameLocation: "middle",
      nameGap: 30,
      axisLabel: {
        //rotate: 45,
      },
    },
    yAxis: {
      type: "value",
      name: t('analytics:growth.cumulativeCount'),
    },
    series: [
      {
        name: t('common:metrics.natural'),
        type: "line",
        smooth: true,
        data: naturalAgg,
        markLine: {
          silent: true,
          symbol: "none",
          lineStyle: {
            type: "dashed",
            color: "#aaa",
            width: 1,
          },
         data: phaseBands
    .filter((band) => band.endIndex !== chartData.length - 1)
    .map((band) => ({
      xAxis: chartData[band.endIndex]?.day.toString(),
    })),
        },
      },
      {
        name: t('common:metrics.culling'),
        type: "line",
        smooth: true,
        data: cullingAgg,
      },
    ],

    // 🟣 Optional
    graphic: phaseBands.map((band, idx) => ({
      type: "text",
      left:
        ((band.startIndex + band.endIndex) / 2 / chartData.length) * 100 + "%",
      top: "5%",
      style: {
        text: band.phase,
        fill: "#999",
        fontSize: 12,
        textAlign: "center",
      },
    })),
    grid: {
      top: 100,
      bottom: 80,
      left: 60,
      right: 40,
    },
  };

  return (
    <div className="Temp">
      <ReactECharts
        option={option}
        style={{ height: "400px", width: "100%" }}
        opts={{ renderer: "svg" }}
      />
    </div>
  );
};

export default NaturalVsCullingChart;
